export enum MenuStatus {
    Open,
    Closed,
}
